var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "folder",
    transform: "translate(2 4.005)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3028",
    "data-name": "Rectangle 3028",
    width: 24,
    height: 24,
    transform: "translate(-2 -4.005)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M115.68,152h-5.76a1.92,1.92,0,0,0-1.91,1.92L108,165.44a1.926,1.926,0,0,0,1.92,1.92h15.36a1.926,1.926,0,0,0,1.92-1.92v-9.6a1.926,1.926,0,0,0-1.92-1.92H117.6Z",
    transform: "translate(-109 -152)",
    fill: "#555bf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6711",
    "data-name": "Path 6711",
    d: "M1.6,0h16a1.6,1.6,0,0,1,1.6,1.6v8.8A1.6,1.6,0,0,1,17.6,12H1.6A1.6,1.6,0,0,1,0,10.4V1.6A1.6,1.6,0,0,1,1.6,0Z",
    transform: "translate(-1 4)",
    fill: "#878bfd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.fe2ff067.svg";
export { ForwardRef as ReactComponent };